import { Box } from "@mui/material";
import React, { useEffect, useState } from "react";

type Face = { src: string; width: number; height: number };

const faces: Face[] = [
  { src: "jg.png", width: 380, height: 800 },
  { src: "lh.png", width: 384, height: 512 },
  { src: "sg.png", width: 510, height: 760 },
  { src: "sr.png", width: 380, height: 550 },
  { src: "lj.png", width: 280, height: 528 },
  { src: "rm.png", width: 765, height: 765 },
];

const spin = new Audio(`${process.env.PUBLIC_URL}/spin.mp3`);

export default function Spinner({
  scale = 1,
  className = "div",
}: {
  scale?: number;
  className?: string;
}) {
  const [faceIndex, setFaceIndex] = useState(
    Math.floor(Math.random() * faces.length)
  );

  const colAngleRef = React.useRef<number | undefined>();
  const [colAngle, setColAngle] = useState<number | undefined>();
  const actuallySetColAngle = (state: number | undefined) => {
    colAngleRef.current = state;
    setColAngle(state);
  };

  const rCountRef = React.useRef<number>(0);
  const globalFaceIndexRef = React.useRef(faceIndex);
  const actuallySetFaceIndex = (state: number) => {
    globalFaceIndexRef.current = state;
    setFaceIndex(state);
  };

  useEffect(() => {
    const doAnim = () => {
      if (rCountRef.current < 25) {
        actuallySetColAngle(undefined);
        spin.pause();
      } else if (rCountRef.current === 25) {
        spin.play();
        actuallySetColAngle(0);
      } else if (rCountRef.current > 25) {
        actuallySetColAngle(((colAngleRef.current ?? 0) + 20) % 360);
      }
    };

    const cycleFace = (e: any) => {
      if (e.key === "r") {
        rCountRef.current = (rCountRef.current ?? 0) + 1;
        actuallySetFaceIndex((globalFaceIndexRef.current + 1) % faces.length);
        doAnim();
      }
    };

    const resetCount = (e: any) => {
      if (e.key === "r") {
        rCountRef.current = 0;
        doAnim();
      }
    };

    document.addEventListener("keydown", cycleFace);
    document.addEventListener("keyup", resetCount);

    return () => {
      document.removeEventListener("keydown", cycleFace);
      document.removeEventListener("keyup", resetCount);
    };
  }, []);

  const face = faces[faceIndex];

  return (
    <Box className={className}>
      <img
        style={{
          filter:
            colAngle !== undefined
              ? `sepia(100%) saturate(300%) brightness(70%) hue-rotate(${colAngle}deg)`
              : undefined,
        }}
        src={`${process.env.PUBLIC_URL}/${face.src}`}
        alt={`/${face.src}`}
        className="rotate"
        width={face.width * scale}
        height={face.height * scale}
        data-testid="face"
      />
    </Box>
  );
}
